import React, { useState, useRef } from "react";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import * as Yup from "yup";
import TextField from "@material-ui/core/TextField";
import { CircularProgress } from "@material-ui/core";

import MakeAPICall from "../../apiCalls/common";

import { searchDoctorsApiRoute, searchPatientsApiRoute } from "../../apiRoutes";
import { getFormattedMonthDate } from "../../utils/dateTimeHelper";

import Error from "../../components/error";
import Button from "../../components/button";
import ICInput from "../../components/form/input";
import { KeyboardDatePicker } from "@material-ui/pickers";

const GenerateTicketForm = props => {
  const [apiCallParams, setApiCallParams] = useState(null);
  const [doctorOpen, setDocOpen] = useState(false);
  const [doctor, setDoctor] = useState(null);
  const [doctorList, setDoctorList] = useState([]);
  const [doctInputErr, setDocInputErr] = useState("");
  const [patientOpen, setPatOpen] = useState(false);
  const [patient, setPatient] = useState(null);
  const [patientList, setPaitentList] = useState([]);
  const [patInputErr, setPatInputErr] = useState("");
  const [loading, setLoading] = useState(false);

  let docInputInterval = useRef();
  let patInputInterval = useRef();

  // call the search api when the user will stop typing
  const setDoctorInputVal = val => {
    clearTimeout(docInputInterval.current);

    setDoctor({ id: "", name: val });

    docInputInterval.current = setTimeout(() => {
      // if (val && val.length > 2) {
      if (val !== null) {
        setDocOpen(true);
        setLoading(true);

        setApiCallParams({
          reqType: "GET",
          reqUrl: searchDoctorsApiRoute,
          params: { searchParam: val, limit: 10 },
          successCallback: res => {
            setLoading(false);
            setDoctorList(res.data.data.doctors);
            if (res.data.data.doctors.length === 0) {
              setDocOpen(false);
            }
          },
          failureCallback: err => {
            setLoading(false);
            setDocOpen(false);
          }
        });
      }
    }, 1000);
  };

  const setPatientInputVal = val => {
    clearTimeout(patInputInterval.current);

    setPatient({ id: "", name: val });

    patInputInterval.current = setTimeout(() => {

      // if (val && val.length > 2) {
      if (val !== null) {
        setPatOpen(true);
        setLoading(true);

        setApiCallParams({
          reqType: "GET",
          reqUrl: searchPatientsApiRoute,
          params: { searchParam: val, limit: 10 },
          successCallback: res => {
            setLoading(false);
            setPaitentList(res.data.data.patients);
            if (res.data.data.patients.length === 0) {
              setPatOpen(false);
            }
          },
          failureCallback: err => {
            setLoading(false);
            setPatOpen(false);
          }
        });
      }
    }, 1000);
  };

  const setSelectedDoctor = doct => {
    setDoctor(doct);
    setDocOpen(false);
    setDoctorList([]);
  };

  const setSelectedPatient = pat => {
    setPatient(pat);
    setPatOpen(false);
    setPaitentList([]);
  };

  const formik = useFormik({
    initialValues: {
      responsible: "",
      subject: "",
      notes: "",
      followUpDate: new Date(new Date().setDate(new Date().getDate() + 3))
    },
    validationSchema: Yup.object({
      responsible: Yup.string()
        .trim()
        .required("Please select responsible"),
      subject: Yup.string()
        .trim()
        .required("Please select subject"),
      followUpDate: Yup.mixed().required("Please select Follow-up Date"),
    }),
    onSubmit: values => {
      let inval = false;
      if (doctor === null) {
        setDocInputErr("Please select doctor");
        inval = true;
      } else if (doctor.id === "") {
        setDocInputErr("Please select doctor from the appeared list");
        inval = true;
      } else {
        setDocInputErr("");
      }

      if (patient === null) {
        setPatInputErr("Please select patient");
        inval = true;
      } else if (doctor.id === "") {
        setPatInputErr("Please select patient from the appeared list");
        inval = true;
      } else {
        setPatInputErr("");
      }

      if (inval !== true) {
        const formData = new FormData();
        formData.append("doctorId", doctor.id);
        formData.append("patientId", patient.id);
        formData.append("responsible", values.responsible);
        // formData.append("message", values.notes);
        formData.append("adminNote", values.notes);
        formData.append("subject", values.subject);
        formData.append("followUpDate", values.followUpDate.toISOString());

        props.addTicketData(formData);
      }
    }
  });

  return (
    <div className="d-flex flex-row flex-wrap justify-content-between">
      <form className="w-100" onSubmit={formik.handleSubmit}>
        <h4 className="mb-4">Generate a New Ticket</h4>
        <div className="form-group row align-items-center">
          <label className="col-sm-2 col-form-label">
            Doctor: <span className="error">*</span>
          </label>
          <div className="col-sm-5 position-relative">
            <ICInput
              name="doctor"
              type="text"
              label="Search Doctors..."
              value={doctor !== null ? doctor.name : ""}
              onChange={e => {
                setDoctorInputVal(e.target.value);
              }}
              error={doctInputErr.length > 0 ? true : false}
              helperText={doctInputErr}
            />
            {doctorOpen === true && (
              <div className="custom-dropdown-search-list">
                {loading && (
                  <div className="list-loader">
                    <CircularProgress
                      disableShrink
                      className="primary-loader"
                    />
                  </div>
                )}
                {!loading && doctorList && doctorList.length > 0 && (
                  <ul>
                    {doctorList.map((item, index) => {
                      let dob = getFormattedMonthDate(item.dateOfBirth);
                      return (
                        <li
                          onClick={e => {
                            let name = item.firstName.trim() + " ";

                            if (
                              item.middleName &&
                              item.middleName.trim().length > 0
                            ) {
                              name = name + item.middleName + " ";
                            }

                            name = name + item.lastName;
                            setSelectedDoctor({
                              id: item._id,
                              name: name
                            });
                          }}
                          key={index}
                        >
                          <div className="item-container">
                            <p className="name">
                              {item.firstName}{" "}
                              {item.middleName ? item.middleName + " " : ""}
                              {item.lastName}
                            </p>
                            <p>
                              {item.gender}&nbsp;&nbsp;&nbsp;DOB:&nbsp;
                              {dob}
                              &nbsp;&nbsp;&nbsp;UIN:&nbsp;{item.doctorId}
                            </p>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="form-group row align-items-center">
          <label className="col-sm-2 col-form-label">
            Patient: <span className="error">*</span>
          </label>
          <div className="col-sm-5 position-relative">
            <ICInput
              name="patient"
              type="text"
              label="Search Patients..."
              value={patient !== null ? patient.name : ""}
              onChange={e => {
                setPatientInputVal(e.target.value);
              }}
              error={patInputErr.length > 0 ? true : false}
              helperText={patInputErr}
            />
            {patientOpen === true && (
              <div className="custom-dropdown-search-list">
                {loading && (
                  <div className="list-loader">
                    <CircularProgress
                      disableShrink
                      className="primary-loader"
                    />
                  </div>
                )}
                {!loading && patientList && patientList.length > 0 && (
                  <ul>
                    {patientList.map((item, index) => {
                      let dob = getFormattedMonthDate(item.dateOfBirth);
                      return (
                        <li
                          onClick={e =>
                            setSelectedPatient({
                              id: item._id,
                              name: item.firstName + " " + item.lastName
                            })
                          }
                          key={index}
                        >
                          <div className="item-container">
                            <p className="name">
                              {item.firstName} {item.lastName}
                            </p>
                            <p>
                              {item.gender}&nbsp;&nbsp;&nbsp;DOB:&nbsp;
                              {dob}
                              &nbsp;&nbsp;&nbsp;UIN:&nbsp;{item.patientId}
                            </p>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>
            )}
          </div>
        </div>

        <hr className="mt-4 mb-4" />

        <div className="form-group row mt-4">
          <label className="col-sm-2 col-form-label">
            Responsible: <span className="error">*</span>
          </label>
          <div className="col-sm-5">
            <TextField
              name="responsible"
              className="w-100"
              select
              value={formik.values.responsible}
              SelectProps={{
                native: true
              }}
              {...formik.getFieldProps("responsible")}
              error={
                formik.touched.responsible && formik.errors.responsible
                  ? true
                  : false
              }
              helperText={
                formik.touched.responsible && formik.errors.responsible
                  ? formik.errors.responsible
                  : ""
              }
            >
              <option>Select a Responsible</option>
              {props.staffList.map(staff => (
                <option key={staff.id} value={staff.id}>
                  {staff.name}
                </option>
              ))}
            </TextField>
          </div>
        </div>

        <hr className="mt-4 mb-4" />

        <h4 className="mb-4">Ticket Details</h4>

        <div className="form-group row">
          <label className="col-sm-2 col-form-label">
            Subject: <span className="error">*</span>
          </label>
          <div className="col-sm-5">
            <TextField
              name="subject"
              className="w-100"
              select
              value={formik.values.subject}
              SelectProps={{
                native: true
              }}
              {...formik.getFieldProps("subject")}
              error={
                formik.touched.subject && formik.errors.subject ? true : false
              }
              helperText={
                formik.touched.subject && formik.errors.subject
                  ? formik.errors.subject
                  : ""
              }
            >
              <option>Select Subject</option>
              <option value="Pathology Request Created">
                Pathology Request Created
              </option>
              <option value="Radiology Request Created">
                Radiology Request Created
              </option>
              <option value="Pathology Results Received">
                Pathology Results Received
              </option>
              <option value="Radiology Report Received">
                Radiology Report Received
              </option>
              <option value="Specialist Letter Received">
                Specialist Letter Received
              </option>
            </TextField>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2 col-form-label">Follow-up Date:</label>
          <div className="col-sm-5">
            <KeyboardDatePicker
              name="followUpDate"
              autoOk
              className="w-100"
              variant="inline"
              mask="__-__-____"
              format="DD-MM-YYYY"
              value={formik.values.followUpDate}
              onChange={date => {
                formik.setFieldValue("followUpDate", date);
              }}
              error={formik.touched.followUpDate && formik.errors.followUpDate ? true : false}
              helperText={
                formik.touched.followUpDate && formik.errors.followUpDate
                  ? formik.errors.followUpDate
                  : ""
              }
              minDate={new Date()}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2 col-form-label">Notes:</label>
          <div className="col-sm-5">
            <TextField
              name="notes"
              className="w-100 dynamic-textarea"
              multiline
              value={formik.values.notes}
              {...formik.getFieldProps("notes")}
              error={formik.touched.notes && formik.errors.notes ? true : false}
              helperText={
                formik.touched.notes && formik.errors.notes
                  ? formik.errors.notes
                  : ""
              }
            />
          </div>
        </div>
        <Error>{props.errorMessage}</Error>
        <br />
        <div className="d-flex flex-row flex-wrap justify-content-center mt-4">
          <Button className="mb-4" title="Submit" type="submit" />
          <Button
            className="ml-4 mb-4"
            title="Reset"
            type="button"
            clickEvent={e => {
              formik.resetForm();
              setDoctor(null);
              setPatient(null);
            }}
          />
        </div>
      </form>
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams} />
    </div>
  );
};

export default GenerateTicketForm;

GenerateTicketForm.defaultProps = {
  errorMessage: ""
};

GenerateTicketForm.propTypes = {
  staffList: PropTypes.array.isRequired,
  addTicketData: PropTypes.func.isRequired,
  errorMessage: PropTypes.string
};
